const styles = {
  title: {
    textAlign: "center",
    fontWeight: "heavy",
    fontSize: 13,
    textDecoration: "underline",
    paddingTop: 20
  },
  signature: {
    display: "flex",
    flexDirection: "row",
    fontWeight: "medium"
  },
  signatureSignLine: {
    left: 7
  },
  signatureNameLine: {
    paddingLeft: 23
  },
  signatureDateLine: {
    paddingLeft: 29
  },
  signaturePlaceLine: {
    paddingLeft: 25
  },
  agreementList: {
    paddingLeft: "5%",
    paddingTop: 10
  },
  signatureBlock: {
    paddingTop: 15
  },
  headerinfo: {
    paddingTop: 20
  },
  mainText: {
    paddingTop: 7
  },
  agreementText: {
    paddingTop: 15,
    paddingBottom: 5
  },
  subjectText: {
    paddingTop: 7,
    paddingBottom: 5
  },
  note: {
    paddingTop: 7,
    fontWeight: "heavy",
    fontSize: 11,
    textDecoration: "underline"
  },
  list: {
    paddingLeft: 19
  },
  listText: {
    paddingLeft: 5
  },
  bulletPointContainer: {
    display: "flex",
    justifyContent: "center"
  },
  bulletPoint: {
    fontWeight: "bold",
    fontSize: 12,
    paddinRight: "50%"
  }
};

export default styles;
